<template>
  <div class="ppc2">
    <Header :title="title"></Header>
    <section class="hero is-small">
      <div class="hero-body">
        <div class="container level">
          <div class="field">
            <div class="control">
              <p class="title is-size-5 level-item"> {{ this.today | moment("dddd, MMMM Do YYYY") }} </p>
            </div>
          </div>

          <!-- <div class="dropdown is-active is-right is-hoverable"> -->
          <div class="dropdown is-right is-hoverable">
            <div class="dropdown-trigger">
              <button aria-controls="dropdown-menu" aria-haspopup="true" class="button">
                <span>Options</span>
                <span class="icon is-small">
                  <i aria-hidden="true" class="fas fa-angle-down"></i>
                </span>
              </button>
            </div>
            <div class="dropdown-menu" id="dropdown-menu" role="menu">
              <div class="dropdown-content">
                <a @click="closeRate" class="dropdown-item">Close rate CHECK</a>
                <a @click="acquiredPlus(0.5)" class="dropdown-item">acquiredPlus</a>
                <a @click="conversionsPlus(0.5)" class="dropdown-item">NUM OF CONVERSIONS</a>
                <a @click="costPerConversionPlus" class="dropdown-item">costperconversionplus</a>
                <a @click="closeRateTen" class="dropdown-item">Close rate: 10% - Low</a>
                <a @click="closeRateTwenty" class="dropdown-item">Close rate: 20% - Typical</a>
                <a @click="closeRateThirty" class="dropdown-item">Close rate: 30% - Best in class</a>
              <hr class="dropdown-divider" />
                <a @click="closeRateEcommerce" class="dropdown-item">Industry: E-commerce</a>
                <!-- <a class="dropdown-item" @click="closeRateEnterprise">Industry: Enterprise</a> -->
              <hr class="dropdown-divider" />
                <a @click="agencyFeesIncluded = !agencyFeesIncluded" class="dropdown-item">
                  <span v-show="agencyFeesIncluded">Exclude agency cost</span>
                  <span v-show="!agencyFeesIncluded">Include agency cost</span>
                </a>
              <hr class="dropdown-divider" />
                <a @click="resetValues" class="dropdown-item">Reset values</a>
                <a @click="dummyValues" class="dropdown-item">Dummy values</a>
              <hr class="dropdown-divider" />
                <a @click="downloadPptx('.pptx-export, [data-pptx-export]')" class="dropdown-item">Download PPTX</a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="container">

      <a href="#" class="ss-download-link ss-exclude" @click.prevent="downloadSs('.pptx-funnels')"></a>
      <div class="tile is-ancestor has-text-centered pptx-funnels pptx-export">
        <div class="tile is-parent pptx-campaigns pptx-export">
          <article class="tile is-child box">

            <div class="pptx-export">
              <h2 class="title is-size-4">
                Campaigns
                <a href="#" class="ss-download-link ss-exclude" @click.prevent="downloadSs('.pptx-campaigns')"></a>
              </h2>

              <Funnel ref="marketingFunnel" :segments="[
                    {ratio:(costPerClick!==0&&!isNaN(costPerClick)) ? 1/costPerClick : 0, label:'CPC', suffix:' clicks', ratioStringOverride: this.currencyPrefix+parseFloat(costPerClick).toFixed(2)+this.currencySuffix},
                    {ratio:conversionRate/100, label:'Conversion Rate', suffix:' conversions'},
                  ]" scaling="flattened" :skip-zero-ratios="false" :show-calculated-percentages="false"
                  :input-value="adSpend" input-prefix="£" input-suffix=" ad spend"
                  :input-subtitle="`Annual spend of ${formatNumber(adSpend * 12)}`"
              />
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Amount paid to Google to run ads.">Ad spend per month
                  <span @click="showModal" class="icon">
                  <i class="fas fa-question-circle"></i>
              </span>
                </label>
              </div>
              <div class="field-body column">
                <div class="field">
                  <div class="control">
                    <money :adSpend="adSpend" class="input" v-bind="moneyNoDecimal" v-model="adSpend"></money>
                  </div>
<!--                  <p class="annual-spend" v-if="adSpend !== 0">Annual spend of {{ formatNumber(adSpend * 12) }}</p>-->
                </div>
              </div>
            </div>

            <span v-show="agencyFeesIncluded">
              <div class="field columns">
                <div class="field-label column">
                  <label class="label tooltip-top" data-tooltip="Novicell optimisation and management fee.">Agency cost per month
                  </label>
                </div>
                <div class="field-body column">
                  <div class="field">
                    <div class="control">
                      <money :agencyCost="agencyCost" class="input" v-bind="moneyNoDecimal"
                             v-model="agencyCost"></money>
                    </div>
                    <p class="annual-spend" v-if="agencyCost !== 0">Annual agency cost of {{ formatNumber(agencyCost * 12) }}</p>
                  </div>
                </div>
              </div>
            </span>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top"
                       data-tooltip="Price you pay Google for each ad click and visit to you site.">Average
                  cost-per-click</label>
              </div>
              <div class="field-body column">
                <div class="field">
                  <div class="control">
                    <money class="input" v-bind="money" v-model="costPerClick"></money>
                  </div>
                </div>
              </div>
            </div>

<!--            <div class="field columns">-->
<!--              <div class="field-label column">-->
<!--                <label class="label tooltip-top" data-tooltip="Visits to your website from ads.">Total website-->
<!--                  visits</label>-->
<!--              </div>-->
<!--              <div class="column">-->
<!--                <p v-if="costPerClick !== 0"> {{ formatNumberOnly(websiteVisits) }} new visits</p>-->
<!--              </div>-->
<!--            </div>-->

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Percentage of users who take a desired action. ">Website
                  conversion rate
                  <span @click="showModalConversion" class="icon">
                    <i class="fas fa-question-circle"></i>
                  </span>
                </label>

              </div>
              <div class="field-body column">
                <div class="field">
                  <div class="control">
                    <money class="input" v-bind="percent" v-model="conversionRate"></money>
                  </div>
                </div>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Total number of conversions.">Conversions or leads</label>
              </div>
              <div class="column">
                <p v-if="conversionRate !== 0"> {{ formatNumberOnly(conversions) }} new leads</p>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="How much you pay for each lead.">Cost per raw
                  conversion</label>
              </div>
              <div class="column">
                <p v-if="conversionRate !== 0"> {{ formatNumber(costPerConversion) }} </p>
              </div>
            </div>


          </article>
        </div>
        <div class="tile is-parent pptx-sales pptx-export">
          <article class="tile is-child box">

            <div class="pptx-export">
              <h2 class="title is-size-4">
                Sales funnel
                <a href="#" class="ss-download-link ss-exclude" @click.prevent="downloadSs('.pptx-sales')"></a>
              </h2>

              <Funnel ref="salesFunnel" :segments="[
                  {ratio:percentageResponse/100, label:'Quality leads', suffix:' leads'},
                  {ratio:percentageProposals/100, label:'Proposal given', suffix:' proposals'},
                  {ratio:percentageAcquired/100, label:'Customers acquired', suffix:' customers'}
                ]" :inputValue="isNaN(conversions)?0:conversions" scaling="quadratic" inputSuffix=" prospects" />

            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Percentage of leads that receive a response.">Quality
                  leads</label>
              </div>
              <div class="column">
                <div class="control">
                  <money class="input" v-bind="percentNoDecimal" v-model="percentageResponse"></money>
<!--                  <p>-->
<!--                    <span v-if="percentageResponse !== 0 && conversionRate !== 0"> {{ formatNumberOnly(qualityLeads) }} leads </span>-->
<!--                  </p>-->
                </div>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Percentage that you then send a proposal or quote.">Proposal
                  given</label>
              </div>
              <div class="column">
                <div class="control">
                  <money class="input" v-bind="percentNoDecimal" v-model="percentageProposals"></money>
<!--                  <span v-if="percentageProposals !== 0 && conversionRate !== 0">{{ formatNumberOnly(proposals) }} proposals</span>-->
                </div>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Percentage that become a paying client.">New customer
                  acquired</label>
              </div>
              <div class="column">
                <div class="control">
                  <money class="input" v-bind="percentNoDecimal" v-model="percentageAcquired"></money>
<!--                  <span v-if="percentageAcquired !== 0 && conversionRate !== 0">{{ formatNumberOnly(acquired) }} new customers</span>-->
                </div>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Mean average deal size or basket size.">Average deal
                  size</label>
              </div>
              <div class="column">
                <div class="control">
                  <money class="input" v-bind="moneyNoDecimal" v-model="dealSize"></money>
                </div>
              </div>
            </div>


            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Gross sales margin.">Margin</label>
              </div>
              <div class="column">
                <div class="control">
                  <money class="input" v-bind="percentNoDecimal" v-model="margin"></money>
                </div>
              </div>
            </div>


          </article>
        </div>

      </div>
    </section>

    <section class="container feat-boxes pptx-export" data-pptx-align="bottom">
      <a href="#" class="ss-download-link ss-exclude" @click.prevent="downloadSs('.feat-boxes')"></a>


      <div class="tile is-ancestor has-text-centered">
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title" v-if="dealSize !== 0 && margin !== 0"> {{ formatNumber(netRevenue) }} </p>
            <p class="title" v-else>£0</p>
            <p class="subtitle">Rev. per lead</p>
          </article>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title" v-if="adSpend !== 0 && acquired !== 0"> {{ formatNumber(costPerSale) }} </p>
            <p class="title" v-else>£0</p>
            <p class="subtitle">Cost per sale</p>
          </article>
        </div>
        <div class="tile is-parent">
          <article :class="{'highlightGreen': (profit > 0),  'highlightRed': (profit < 0)}" class="tile is-child box">
            <p class="title" v-if="costPerSale !== 0 && netRevenue !== 0"> {{ formatNumberOnly(returnOnPaidInvestment)
              }}% </p>
            <p class="title" v-else>0%</p>
            <p class="subtitle">{{ agencyFeesIncluded ? 'ROI' : 'ROAS' }}</p>
          </article>
        </div>
        <div class="tile is-parent">

          <article :class="{'highlightGreen': (profit > 0),  'highlightRed': (profit < 0)}" class="tile is-child box">
            <p class="title" v-if="costPerSale !== 0 && netRevenue !== 0"> £{{ formatNumberOnly(profit) }} </p>
            <p class="title" v-else>£0</p>
            <p class="subtitle">Profit monthly</p>
          </article>
        </div>
        <div class="tile is-parent">
          <article :class="{'highlightGreen': (profit > 0),  'highlightRed': (profit < 0)}" class="tile is-child box">
            <p class="title" v-if="costPerSale !== 0 && netRevenue !== 0"> £{{ formatNumberOnly(profit * 12) }} </p>
            <p class="title" v-else>£0</p>
            <p class="subtitle">Profit annual
            </p>
          </article>
        </div>
      </div>
    </section>

    <ModalAdSpend></ModalAdSpend>
    <ModalConversionRate></ModalConversionRate>

    <section class="box container pptx-export" id="scenario-analysis" v-show="profit">

      <h1 class="title is-size-4">
        Scenario analysis
        <a href="#" class="ss-download-link ss-exclude" @click.prevent="downloadSs('#scenario-analysis')"></a>
      </h1>
      <h2 class="title is-size-5">Scenario 1: Conversion Rate of {{ conversionRate }}%</h2>
      <div class="level is-centered">
        <table class="table is-hoverable is-narrow is-centered" v-show="acquired">
          <thead class="is-size-5">
          <tr>
            <th><abbr class="is-size-6" title="Scenario">Cumulative</abbr></th>
            <th v-for="(_, i) in 12"> {{ today | moment("add", i+" month", "MMM") }}</th>
          </tr>
          </thead>
          <tbody class="is-size-7">
          <tr>
            <td class="is-size-6">Revenue</td>
            <td v-for="(_, i) in 12"> {{ formatNumber(acquired * dealSize * (i+1)) }}</td>
          </tr>
          <tr>
            <td class="is-size-6">Profit</td>
            <td v-for="(_, i) in 12"> {{ formatNumber(profit * (i+1)) }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <h2 class="title is-size-5">Scenario 2: Conversion Rate of {{ conversionRate + 0.5 }}%</h2>
      <div class="level is-centered">
        <table class="table is-hoverable is-narrow is-centered" v-show="acquired">
          <thead class="is-size-5">
          <tr>
            <th><abbr class="is-size-6" title="Scenario">Cumulative</abbr></th>
            <th v-for="(_, i) in 12"> {{ today | moment("add", i+" month", "MMM") }}</th>
          </tr>
          </thead>
          <tbody class="is-size-7">
          <tr>
            <td class="is-size-6">Revenue</td>
            <td v-for="(_, i) in 12"> {{ formatNumber(acquiredPlus(0.5) * dealSize * (i+1)) }}</td>
          </tr>
          <tr>
            <td class="is-size-6">Profit</td>
            <td v-for="(_, i) in 12"> {{ formatNumber(profitPlus(0.5) * (i+1)) }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="column">
        <PPCChart :chart-data="datacollection"></PPCChart>
      </div>
    </section>

    <!-- <img src="//image.thum.io/get/https://www.google.co.uk/search?q=life+insurance+quotes" /> -->

    <Footer></Footer>

  </div>
</template>

<script>
  import Header from '../components/Header'
  import PPCChart from '../components/PPCChart'
  import Footer from '../components/Footer'
  import ModalAdSpend from '../components/ModalAdSpend'
  import ModalConversionRate from '../components/ModalConversionRate'
  import TableScenario from '../components/TableScenario'
  import NumericValueInput from "../components/molecules/NumericValueInput"
  import CalculatedValueInput from "../components/molecules/CalculatedValueInput"
  import Funnel from '../components/molecules/Funnel'

  import { Money } from 'v-money'
  import moment from 'moment'

  import { PptxDownload } from '../PptxDownload';

  export default {
    name: 'PPC2',
    components: {
      Funnel,
      NumericValueInput,
      CalculatedValueInput,
      Header,
      Money,
      PPCChart,
      Footer,
      ModalAdSpend,
      ModalConversionRate,
      TableScenario
    },
    data() {
      return {
        currencyPrefix: '£ ',
        currencySuffix: '',
        testField: 123,
        title: 'PPC budget tool',
        moment: moment,
        today: new Date(),
        month1: this.today | moment("MMM"),
        adSpend: '',
        agencyCost: '',
        agencyFeesIncluded: false,
        testValue: 99,
        costPerClick: '',
        conversionRate: '',
        percentageResponse: 0,
        percentageProposals: '',
        percentageAcquired: '',
        dealSize: '',
        margin: '',
        isActive: false,
        money: {
          // The character used to show the decimal place.
          decimal: '.',
          // The character used to separate numbers in groups of three.
          thousands: ',',
          // The currency name or symbol followed by a space.
          prefix: '£',
          // The suffix (If a suffix is used by the target currency.)
          suffix: '',
          // Level of decimal precision. REQUIRED
          precision: 2,
          // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
          masked: false
        },
        moneyNoDecimal: {
          // The character used to show the decimal place.
          decimal: '.',
          // The character used to separate numbers in groups of three.
          thousands: ',',
          // The currency name or symbol followed by a space.
          prefix: '£',
          // The suffix (If a suffix is used by the target currency.)
          suffix: '',
          // Level of decimal precision. REQUIRED
          precision: 0,
          // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
          masked: false
        },
        percent: {
          // The character used to show the decimal place.
          decimal: '.',
          // The character used to separate numbers in groups of three.
          thousands: '',
          // The currency name or symbol followed by a space.
          prefix: '',
          // The suffix (If a suffix is used by the target currency.)
          suffix: '%',
          // Level of decimal precision. REQUIRED
          precision: 2,
          // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
          masked: false
        },
        percentNoDecimal: {
          // The character used to show the decimal place.
          decimal: '.',
          // The character used to separate numbers in groups of three.
          thousands: '',
          // The currency name or symbol followed by a space.
          prefix: '',
          // The suffix (If a suffix is used by the target currency.)
          suffix: '%',
          // Level of decimal precision. REQUIRED
          precision: 0,
          // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
          masked: false
        },
        // instantiating datacollection with null
        datacollection: null
      }
    },
    watch: {
      profit(newValue, oldValue) {
        console.log('new value: ' + newValue)
        console.log('old value: ' + oldValue)

        this.fillData()
      }
    },
    computed: {
      date: function () {
        return this.today.getFullYear() + '-' + (this.today.getMonth() + 1) + '-' + this.today.getDate()
      },
      websiteVisits: function () {
        return this.adSpend / this.costPerClick
      },
      conversions: function () {
        return ((this.adSpend / this.costPerClick) * this.conversionRate) / 100
      },
      costPerConversion: function () {
        return (this.adSpend + this.agencyCost) / this.conversions
      },
      qualityLeads: function () {
        return (this.conversions * this.percentageResponse) / 100
      },
      proposals: function () {
        return (this.qualityLeads * this.percentageProposals) / 100
      },
      acquired: function () {
        return (this.proposals * this.percentageAcquired) / 100
      },
      netRevenue: function () {
        return (this.dealSize * this.margin) / 100
      },
      costPerSale: function () {
        return (this.adSpend + this.agencyCost) / this.acquired
      },
      returnOnPaidInvestment: function () {
        return ((this.netRevenue - this.costPerSale) / this.costPerSale) * 100
      },
      profit: function () {
        return (this.netRevenue - this.costPerSale) * this.acquired
      },
    },
    created() {
      // anytime the vue instance is created, call the fillData() function.
      this.fillData()
    },
    methods: {
      downloadPptx: async function (id) {
        const pptx = await PptxDownload.GenerateFromDomElements(document.querySelectorAll(id));
        pptx.save("PPC budget");
      },
      downloadSs: async function (id) {
        const canvas = await PptxDownload.RenderDomElement(document.querySelector(id));
        PptxDownload.OpenImageDataUrlInNewWindow(canvas.toDataURL());
      },
      profitPlus: function (x) {
        return (this.netRevenue - this.costPerSale) * this.acquiredPlus(x)
      },
      conversionsPlus: function (cr) {
        return ((this.adSpend / this.costPerClick) * (this.conversionRate + cr)) / 100;
      },
      costPerConversionPlus: function () {
        return (this.adSpend + this.agencyCost) / this.conversionsPlus(0.5);
      },
      qualityLeadsPlus: function (x) {
        return (this.conversionsPlus(x) * this.percentageResponse) / 100;
      },
      proposalsPlus: function (x) {
        return (this.qualityLeadsPlus(x) * this.percentageProposals) / 100;
      },
      acquiredPlus: function (x) {
        return (this.proposalsPlus(x) * this.percentageAcquired) / 100;
      },
      closeRate() {
        return (this.percentageResponse / 100) * (this.percentageProposals / 100) * (this.percentageAcquired / 100);
      },
      formatNumber(num) {
        num = Math.round(num)
        return "£" + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      },
      formatNumberOnly(num) {
        num = Math.round(num)
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      },
      toggle() {
        this.isActive = !this.isActive
      },
      showModal() {
        let element = document.getElementById('modal')
        element.classList.add('is-active')
      },
      showModalConversion() {
        let element = document.getElementById('modal-conversion')
        element.classList.add('is-active')
      },
      resetValues() {
        this.adSpend = 0
        this.agencyCost = 0
        this.costPerClick = 0
        this.conversionRate = 0
        this.percentageResponse = 0
        this.percentageProposals = 0
        this.percentageAcquired = 0
        this.dealSize = 0
        this.margin = 0
      },
      qualityLeadsSetter() {
        this.qualityLeads = 43
      },
      dummyValues() {
        this.adSpend = 8000
        this.agencyCost = 0
        this.costPerClick = 4.50
        this.conversionRate = 4.00
        this.percentageResponse = 66
        this.percentageProposals = 67
        this.percentageAcquired = 67
        this.dealSize = 9000
        this.margin = 10
      },
      closeRateTen() {
        this.percentageResponse = 50
        this.percentageProposals = 50
        this.percentageAcquired = 40
      },
      closeRateTwenty() {
        this.percentageResponse = 50
        this.percentageProposals = 50
        this.percentageAcquired = 80
      },
      closeRateThirty() {
        this.percentageResponse = 75
        this.percentageProposals = 66.6
        this.percentageAcquired = 60
      },
      closeRateEcommerce() {
        this.percentageResponse = 100
        this.percentageProposals = 100
        this.percentageAcquired = 100
      },
      // closeRateEnterprise () {
      //   this.percentageResponse = 100
      //   this.percentageProposals = 100
      //   this.percentageAcquired = 100
      // },
      returnOnPaidInvestmentFull(cr) {
        // return Math.round(((this.netRevenue - this.costPerSale ) / this.costPerSale) * 100)
        let cps = ((this.adSpend / this.costPerClick) * (cr / 100)) * (this.percentageResponse / 100) * (this.percentageProposals / 100) * (this.percentageAcquired / 100)

        let leads = (this.adSpend / this.costPerClick) * (cr / 100)
        let ql = leads * (this.percentageResponse / 100)
        let pp = ql * (this.percentageProposals / 100)
        let pa = pp * (this.percentageAcquired / 100)

        let cps2 = ((this.adSpend / pa))

        console.log('adspend: ' + this.adSpend)

        console.log('cps ' + cps)
        console.log('cps2 ' + cps2)
        console.log('pa ' + pa)
        console.log('leads ' + leads)
        console.log('netrevenue ' + this.netRevenue)
        console.log('percentResp: ' + this.percentageResponse)
        console.log('percentProp: ' + this.percentageProposals)
        console.log('percentAcquir: ' + this.percentageAcquired)
        console.log('this profit: ' + this.profit)

        return Math.round(cps2)
      },
      fillData() {
        this.datacollection = {
          // Data for the y-axis of the chart
          labels: [moment().add(0, 'months').format('MMM'), moment().add(1, 'months').format('MMM'), moment().add(2, 'months').format('MMM'), moment().add(3, 'months').format('MMM'), moment().add(4, 'months').format('MMM'), moment().add(5, 'months').format('MMM'), moment().add(6, 'months').format('MMM'), moment().add(7, 'months').format('MMM'), moment().add(8, 'months').format('MMM'), moment().add(9, 'months').format('MMM'), moment().add(10, 'months').format('MMM'), moment().add(11, 'months').format('MMM')],
          datasets: [
            {
              label: 'Revenue at conversion Rate of ' + this.conversionRate + '%',
              // backgroundColor: '#7C0435',
              borderColor: '#7C0435',
              borderWidth: 5,
              backgroundColor: 'rgba(124, 4, 53, .1)',
              // Data for the x-axis of the chart
              data: [Math.round(this.acquired * this.dealSize * 1), Math.round(this.acquired * this.dealSize * 2), Math.round(this.acquired * this.dealSize * 3), Math.round(this.acquired * this.dealSize * 4), Math.round(this.acquired * this.dealSize * 5), Math.round(this.acquired * this.dealSize * 6), Math.round(this.acquired * this.dealSize * 7), Math.round(this.acquired * this.dealSize * 8), Math.round(this.acquired * this.dealSize * 9), Math.round(this.acquired * this.dealSize * 10), Math.round(this.acquired * this.dealSize * 11), Math.round(this.acquired * this.dealSize * 12)]
            },
            {
              label: 'Profit at conversion Rate of ' + this.conversionRate + '%',
              // backgroundColor: '#75BC7F',
              borderColor: '#75BC7F',
              borderWidth: 5,
              backgroundColor: 'rgba(117, 188, 127, 0.1)',
              // Data for the x-axis of the chart
              data: [Math.round(this.profit * 1), Math.round(this.profit * 2), Math.round(this.profit * 3), Math.round(this.profit * 4), Math.round(this.profit * 5), Math.round(this.profit * 6), Math.round(this.profit * 7), Math.round(this.profit * 8), Math.round(this.profit * 9), Math.round(this.profit * 10), Math.round(this.profit * 11), Math.round(this.profit * 12)]
            }
          ]
        }
      }
    }

  }
</script>

<style scoped>

  .ppc2 {
    background-color: #F5F5F5;
    /* font-family: "Averta","Arial","sans-serif" !important; */
  }

  #data-input {
    background-color: #FFF;
    /* font-family: "Averta","Arial","sans-serif" !important ; */
  }

  #scenario-analysis {
    background-color: #FFF;
    /* padding-top: 3rem */
    margin-top: 1.5rem;
  }

  .tile.is-ancestor:last-child {
    margin-top: 0.75rem;
  }

  .highlightGreen {
    background-color: #75BC7F;
  }

  .highlightRed {
    background-color: #7C0435;
    color: #fff;
  }
  .highlightRed .title {
    color: #fff;
  }
  .highlightRed .subtitle {
    color: #eaeaea;
  }
  .highlightGreen .subtitle {
    color: #333;
  }


  input.v-money.input {
    background: none;
    box-shadow: none;
    outline: none;
    padding: 5px 8px;
    margin-bottom: 3px;
    margin-top: -6px;
    height: auto;
    border-radius: 0;
    border: 1px solid transparent;
    border-bottom: dashed 3px;
    border-bottom-color: transparent;
  }

  input.v-money.input:focus {
    border: 1px solid #ccc;
    border-bottom: dashed 3px;
    border-bottom-color: #ccc;
    background: rgba(0,0,0, 0.04);
  }

  .ss-download-link:after {
    display: inline;
    content: '📷';
  }
  .ss-download-link {
    display: inline-block;
    font-size: 1rem;
    padding: 0.25em;
    opacity: 0.7;
  }
  *:hover > .ss-download-link {
    opacity: 1;
  }
  .title {
    font-weight: 900;
  }
  .feat-boxes .title {
    font-weight: 800;
  }
  .feat-boxes .subtitle {
    font-weight: 600;
  }
  table th, table td {
    min-width: 4rem;
  }
  .field.columns .column {
    padding: 0.5em;
  }
  .field.columns .field-label {
    margin-right: 1rem;
  }
  .field.columns p {
    font-style: italic;
    font-weight: 600;
  }
</style>
